
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/arrendar-mi-maquinaria",
      function () {
        return require("private-next-pages/arrendar-mi-maquinaria.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/arrendar-mi-maquinaria"])
      });
    }
  